<footer class="footer">
  <div class="container">
    <span>© {{ currentYear }} Data Unveil. All rights reserved.</span>
  </div>
</footer>
